import React from 'react';
import { useNavigate } from 'react-router-dom';
import CollapsibleSection from './CollapsibleSection';

// Icons
const DocumentIcon = () => (
  <svg className="section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);

export interface DocumentCutoff {
  id: string;
  shipmentId?: string;
  reference: string;
  contractRef?: string;
  supplier: string;
  buyer: string;
  carrier?: string;
  cutoffType?: string;
  cutoffDate: string;
  cutoffTime?: string;
  hoursRemaining?: number | null;
  isUrgent?: boolean;
}

interface DocumentCutoffsSectionProps {
  cutoffs: DocumentCutoff[];
  onSearchGmail?: (cutoff: DocumentCutoff) => void;
}

const DocumentCutoffsSection: React.FC<DocumentCutoffsSectionProps> = ({
  cutoffs,
  onSearchGmail,
}) => {
  const navigate = useNavigate();

  const handleReferenceClick = (reference: string) => {
    navigate(`/contracts/${reference}`);
  };

  if (cutoffs.length === 0) {
    return (
      <CollapsibleSection
        title="Document Cutoffs Next 48 Hours"
        count={0}
        icon={<DocumentIcon />}
        variant="default"
      >
        <div className="empty-state">
          <div className="empty-state-icon">✓</div>
          <div className="empty-state-text">No document cutoffs in the next 48 hours</div>
        </div>
      </CollapsibleSection>
    );
  }

  return (
    <CollapsibleSection
      title="Document Cutoffs Next 48 Hours"
      count={cutoffs.length}
      icon={<DocumentIcon />}
      variant="warning"
    >
      <div className="table-wrapper">
        <table className="dash-table">
          <thead>
            <tr>
              <th>Reference</th>
              <th>Supplier</th>
              <th>Buyer</th>
              <th className="sortable">Cutoff</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {cutoffs.map((cutoff) => (
              <tr 
                key={cutoff.id}
                className="priority-urgent"
              >
                <td>
                  <span 
                    className="ref-link"
                    onClick={() => handleReferenceClick(cutoff.reference)}
                  >
                    {cutoff.reference}
                  </span>
                </td>
                <td>{cutoff.supplier}</td>
                <td>{cutoff.buyer}</td>
                <td>{cutoff.cutoffDate}</td>
                <td>
                  <button 
                    className="dash-btn dash-btn-outline dash-btn-sm"
                    onClick={() => onSearchGmail?.(cutoff)}
                  >
                    Search Gmail
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CollapsibleSection>
  );
};

export default DocumentCutoffsSection;
